<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path d="M2 3h7v5H2V3zm0 6h7v5H2V9zm9-6h7v5h-7V3zm0 6h7v5h-7V9z" opacity="0.3"/>
    <path d="M2 14h16v3H2v-3z"/>
    <path d="M9 15.5l-2-1.5v1H4v1h3v1l2-1.5zm7 0l-2-1.5v1h-3v1h3v1l2-1.5z"/>
  </svg>
</template>

<script>
export default {
  name: 'MergeCells',
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    }
  }
}
</script>
